/* eslint-disable import/prefer-default-export */

import { formRedirectEnums, hiddenFormParamEnums } from '../../enums'
import { formRedirectActions, hiddenFormParamActions } from '../actions'
import { reduxTypes, ReduxAction } from '../types'

// const logger = (store) => (next) => (action) => {
//   // console.log('dispatching', action)
//   const result = next(action)
//   // console.log('next state', store.getState())
//   return result
// }

const featureFlagMiddleware = (store) => (next) => (action: ReduxAction<any>) => {
  if (action.type === reduxTypes.FEATURE_FLAG_UPDATE) {
    if (action.payload.newConfirmationPage) {
      const { formRedirect }: { formRedirect: URL } = store.getState()
      formRedirect.pathname = formRedirectEnums.CONFIRMATION_NEW
      store.dispatch(formRedirectActions.update(formRedirect))
      store.dispatch(hiddenFormParamActions.merge([
        {
          default: hiddenFormParamEnums.values.LEADSOURCE2_CONFIRMATION_NEW,
          key: hiddenFormParamEnums.keys.LEADSOURCE2,
        },
      ]))
    }

    else {
      store.dispatch(hiddenFormParamActions.merge([
        {
          default: hiddenFormParamEnums.values.LEADSOURCE2_CONFIRMATION_OLD,
          key: hiddenFormParamEnums.keys.LEADSOURCE2,
        },
      ]))
    }
  }
  next(action)
}

export { featureFlagMiddleware }
